
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fotobox-mieten-geburtstag",
      function () {
        return require("private-next-pages/fotobox-mieten-geburtstag.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fotobox-mieten-geburtstag"])
      });
    }
  